export const DEFAULT_VOLUME = 50;

export const YOUTUBE_PLAYLIST_ITEMS_URL =
  'https://www.googleapis.com/youtube/v3/playlistItems';

export const YOUTUBE_VIDEOS_URL =
  'https://www.googleapis.com/youtube/v3/videos';

// Placeholder playlist for development - swap in the real 2026 election
// video playlist ID when it exists.
export const ELECTION_VIDEOS_PLAYLIST_ID = 'PLcQjUPmu2vrE';

// Placeholder live stream for development - swap in the real 2026 election
// night live stream video ID when it exists.
export const LIVE_STREAM_VIDEO_ID = 'SI1Ul5-Ldb4';

// Uploads playlist for the @MPR_News YouTube channel. Every channel exposes an
// auto-generated uploads playlist whose id is the channel id (UChrfVRXVr1rieeZ4IIFJ7zQ)
// with the "UC" prefix swapped to "UU".
export const MPR_NEWS_UPLOADS_PLAYLIST_ID = 'UUhrfVRXVr1rieeZ4IIFJ7zQ';

// Upper bound (seconds) for treating an upload as a Short. YouTube Shorts run
// up to ~3 minutes; we filter uploads by duration since the channel's Shorts
// tab is not a fetchable playlist.
export const SHORTS_MAX_DURATION_SECONDS = 180;

// How many Shorts to show in the homepage row.
export const HOMEPAGE_SHORTS_COUNT = 5;
